import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import TextLink from "hardcover-ui/components/TextLink";
import Divider from "components/ui/Divider";
import BookReviews from "../BookReview/BookReviews";
import { PageSerializersBooksShow, UserBookSerializersUserBookReview } from "types/serializers";

export default function PopularReviews({
  book,
  reviews,
  limit = 3,
}: {
  book: PageSerializersBooksShow
  reviews: UserBookSerializersUserBookReview[];
  limit?: number;
}) {
  return (
    <div>
      <div className="mb-4">
        <Heading level={3} size="md">
          Popular Reviews
        </Heading>
        <Text as="p" variant="secondary">
          Reviews with the most likes.
        </Text>
      </div>

      {reviews.length > 0 ? (
        <BookReviews reviews={reviews.slice(0,limit)} book={book} expandClass="max-h-64" />
      ) : (
        <Text variant="secondary" size="sm" as="p">
          There are no reviews for this book. <TextLink href={`/books/${book.slug}/reviews/edit`} >Add yours</TextLink> and it'll show up right
          here!
        </Text>
      )}
      <Divider size="lg" />
    </div>
  );
}
